/* eslint-disable consistent-return, no-param-reassign, no-new, consistent-this */

import tracking from "site/page/views/tracking/availability";
import { fetchPaginatedModel } from "./fetch-paginated-model";

const $ = require("jquery");
const _ = require("underscore");
const Backbone = require("backbone");
const WidgetHeaderView = require("site/common/widget-header");
const AvailabilityPageModel = require("site/page/checkout/availability-page-model");
const EmployeeSelectionView = require("site/page/checkout/employee-selection-view");
const WeekdaySelectionView = require("site/page/checkout/weekday-selection-view");
const TimeSelectionView = require("site/page/checkout/time-selection-view");
const BasketSummaryView = require("./basket-summary-view");
const BasketModel = require("site/common/models/basket-model");
const gt = require("common/analytics/google-tagmanager");
const URI = require("URIjs/URI");
const events = require("common/event-aggregator");
const config = require("common/page-config");
require("URIjs/URI.fragmentQuery");

const weekdayCollection = require("./weekday-selection-collection");

const AvailabilityPageView = Backbone.View.extend({
  emptyTemplateId: "empty-basket-summary-template",
  errorTemplateId: "error-basket-summary-template",

  model: new AvailabilityPageModel(),

  views: [],

  ui: {
    loading: $(".loading-message"),
    loadingAvailability: $(".loading-availability-message"),
    voucherSections: $(".basket-summary-wrapper section").filter(
        ".voucher-information, .basket-summary"
      ),
    appointmentSections: $(".basket-summary-wrapper section").filter(
        ".datetime-selection, .basket-summary"
      )
  },

  initialize () {
    var uri, fragment;

    this.listenTo(events, events.BASKET_UPDATED, this.refetchModel);
    this.listenTo(
        events,
        events.CHECKOUT_AVAILABILITY_PAGINATE,
        fetchPaginatedModel.bind(this)
      );

      // get uri parameters
    uri = new URI(window.location.href).fragmentPrefix("");
    fragment = uri.fragment(true);
      // set the model's booking options
    this.model.set("bookingOptions", fragment);

      // get venue basket
    this.basketModel = new BasketModel({
      venueId: this.model.get("bookingOptions").venueId || config.venueId
    });
      // Fetch basket model data and add to view's model
    this.basketModel.fetch().done((basketData) => {
        // if basket is empty show error page
      if (basketData.services.length === 0) {
        this.renderEmptyBasketView(this.emptyTemplateId);
        return;
      }

      const fetchArgs = {
        services: basketData.services,
        employeeId: basketData.employeeId
      };
      if (fragment.date) {
        fetchArgs.startDate = fragment.date;
      }
      this.fetchModel(fetchArgs).then((modelData) => {
        this.model.set(modelData);
        weekdayCollection.resetDayData({
          days: modelData.days,
          referenceSlots: modelData.referenceSlots
        });
        this.render();
      });
    });
  },

  fetchModel ({ services, employeeId, startDate = "", endDate = "" }) {
    this.model.set("basket", services);
    this.model.set("preselectEmployeeId", employeeId);
    var modelUri = this.model.url.replace(
        "{{services}}",
        encodeURIComponent(JSON.stringify(this.prepareBasketData(services)))
      );

    if (startDate) {
      modelUri = modelUri + `&startDate=${startDate}`;
    }
    if (endDate) {
      modelUri = modelUri + `&endDate=${endDate}`;
    }

    return new Promise((resolve, reject) => {
      this.model
          .fetch({
            url: modelUri
          })
          .done(resolve)
          .fail(reject);
    }).then((data) => {
      if (data.appointmentAvailability) {
        var appointmentData = data.appointmentAvailability;

        if (
            _.isEmpty(appointmentData.days) &&
            _.isEmpty(appointmentData.referenceSlots)
          ) {
          this.renderEmptyBasketView(this.errorTemplateId);
          this.basketModel.emptyServices();
          return;
        }
      }

      var extendData,
        modelData = {
          pricing: data.pricing
        };

      extendData = data.appointmentAvailability;

      _.extend(modelData, extendData);

        // add empty array if data doesn't have employees
      if (!data.employees) {
        data.employees = [];
      }

      return modelData;
    });
  },

  refetchModel (services) {
    if (services.length === 0) {
      this.renderEmptyBasketView(this.emptyTemplateId);
      return;
    }

    this.ui.loadingAvailability.show();

    this.fetchModel({ services }).then((modelData) => {
      this.model.set(modelData);

      weekdayCollection.resetDayData({
        days: this.model.get("days"),
        referenceSlots: this.model.get("referenceSlots")
      });
      this.weekdaySelectionView.setData({
        firstIncludedDate: this.model.get("firstIncludedDate"),
        lastIncludedDate: this.model.get("lastIncludedDate"),
        moreDaysInThePast: this.model.get("moreDaysInThePast"),
        moreDaysInTheFuture: this.model.get("moreDaysInTheFuture")
      });
      this.employeeSelectionView.setEmployees(this.model.get("employees"));
      this.employeeSelectionView.render();
      this.weekdaySelectionView.render();
      this.ui.loadingAvailability.hide();
    });
  },

  prepareBasketData (basket) {
    return _.map(basket, function (service) {
      return {
        serviceId: service.serviceId,
        skuIds: _.map(service.skus, function (sku) {
          return sku.choiceId;
        })
      };
    });
  },

  emitPricesAvailable () {
      // Use prices from basket.

    events.trigger(events.CHECKOUT_AVAILABILITY_PRICES, {
      services: _.map(this.model.get("basket"), function (service) {
        return {
          serviceId: service.serviceId,
          skus: _.map(service.skus, function (sku) {
            return {
              skuId: sku.choiceId,
              price: sku.price
            };
          })
        };
      })
    });
  },

  render () {
    this.views = [];
    this.views.push(
        new BasketSummaryView({
          el: ".basket-summary",
          basket: this.model.get("basket"),
          hasTimeSelection: true,
          track: tracking.basketSummary
        })
      );

    this.createAppointmentViews();

      // render created views
    this.renderViews();
  },

  createAppointmentViews () {
    this.weekdaySelectionView = new WeekdaySelectionView({
      el: this.$el.find(".js-navigation"),
      collection: weekdayCollection,
      initialDate: this.model.get("bookingOptions").date || null,
      initialTime: this.model.get("bookingOptions").timeFrom || null,
      track: tracking.dateSelection,
      firstIncludedDate: this.model.get("firstIncludedDate"),
      lastIncludedDate: this.model.get("lastIncludedDate"),
      moreDaysInThePast: this.model.get("moreDaysInThePast"),
      moreDaysInTheFuture: this.model.get("moreDaysInTheFuture")
    });
    this.views.push(this.weekdaySelectionView);

    this.timeSelectionView = new TimeSelectionView({
      el: this.$el.find(".time-selection"),
      timeFrom: this.model.get("bookingOptions").timeFrom || null,
      timeTo: this.model.get("bookingOptions").timeTo || null,
      resetHeightFrom: this.$el.find(".datetime-selection"),
      resetHeightParent: this.$el,
      selectInitialSlot: true,
      selectedTime: this.model.get("bookingOptions").time || null,
      track: tracking.timeSelection
    });
    this.views.push(this.timeSelectionView);

    this.employeeSelectionView = new EmployeeSelectionView({
      el: this.$el.find(".employee-selection"),
      employees: this.model.get("employees"),
      track: tracking.employeeSelection
    });
    this.views.push(this.employeeSelectionView);
  },

  renderViews () {
    _.each(this.views, function (view) {
      view.render();
      view.$el.show();
    });

      // hide/remove loading message
    this.ui.loading.remove();
      // show content
    this.showHeader();
    this.ui.appointmentSections.show();
      // fire page loaded event
    events.trigger(events.CHECKOUT_AVAILABILITY_PAGE_LOADED);

    var preSelectedEmployeeId = this.model.get("preselectEmployeeId");
    if (preSelectedEmployeeId) {
      this.employeeSelectionView.selectEmployee(preSelectedEmployeeId);
    }
  },

  renderEmptyBasketView (templateId) {
    if (!templateId) {
      templateId = this.emptyTemplateId;
    }

    var template = $("#" + templateId).html();
    $(".basket-summary-wrapper").html(template);
      // hide/remove loading message
    this.ui.loading.remove();

    var addService = $(".add-service", this.$el);
    addService.on("click", this.onAddServiceSelected.bind(this));

    if (this.$el.find(".error-go-back").length > 0) {
      this.$el.find(".error-go-back").on("click", function () {
        var url =
            config.postRescheduleUri +
            (document.location.hash ? document.location.hash : "");
        window.location = url;
      });
    }
  },

  onAddServiceSelected (event) {
    var category = config.isMobile ? "basket" : "availability";
    gt.trackEvent(
      {
        category: category,
        property: "additional_services_button",
        action: "click"
      },
      () => {
        this.followExtendedUrl($(event.currentTarget).attr("href"));
      }
      );
  },

  followExtendedUrl (href) {
      // get current url
    var hashFragmentsToInclude = ["highlight-name", "highlight-services"];
    var currentUrl = new URI(document.location.href).fragmentPrefix("");
    var currentUrlFragments = currentUrl.fragment(true);
    var addFragments = _.intersection(
        _.keys(currentUrlFragments),
        hashFragmentsToInclude
      );

      // get link url
    var hrefUrl = new URI(href).fragmentPrefix("");

      // if highlight name is present on the fragments
    if (addFragments.length > 0) {
      _.each(addFragments, function (fragment) {
        hrefUrl.addFragment(fragment, currentUrlFragments[fragment]);
      });
    }

    window.location = hrefUrl.toString();
  },

  showHeader () {
    var $header = this.$el.siblings(".page-header"),
      $title = $header.find("h1"),
      $backLink = $header.find(".back-link");

      // toggle page header sections
    $title.children().hide();
    $title.find(".appointment").show();
      // show back link and attach event to the back button
    $backLink.on("click", this.onGoBack).show();
  },

  onGoBack () {
      // redirect to previous page
    window.history.go(-1);
  }
});

new WidgetHeaderView({ type: "availability" });
new AvailabilityPageView({
  el: $(".basket-summary-wrapper")
});
